module.exports = __webpack_public_path__ + "static/img/蛋白表达.8eacbce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/二级标题Banner/蛋白表达.jpg
// module id = oSio
// module chunks = 1